// extracted by mini-css-extract-plugin
export default {"iconButton":"Icons_iconButton__kn5Nk"};